import {
  A4_DIMENSIONS_PX,
  type Page,
} from "@/components/common/report-builder/constants";

export const generateUniqueId = (prefix: string) => {
  return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
};

export const initialPage: Page = {
  id: `page-${Date.now()}`,
  name: "Page 1",
  items: [],
  size: A4_DIMENSIONS_PX.portrait,
  isTitlePage: false,
  padding: 0,
  backgroundColor: "#ffffff", // Default white background
  backgroundImage: undefined,
  thumbnailDirty: true, // Mark as needing thumbnail capture
};

/**
 * Generates a default 3x3 TipTap table structure with proper cell heights
 * @returns TipTap JSON structure for a 3x3 table
 */
export const generateDefaultBasicTable = () => {
  const rows = 3; // 1 header row + 2 body rows
  const cols = 3;

  const tableRows = [];
  for (let i = 0; i < rows; i++) {
    const isHeaderRow = i === 0;
    const cells = [];
    
    for (let j = 0; j < cols; j++) {
      cells.push({
        type: isHeaderRow ? "tableHeader" : "tableCell",
        attrs: {
          colspan: 1,
          rowspan: 1,
          colwidth: null,
        },
        content: [
          {
            type: "paragraph",
            content: [],
          },
        ],
      });
    }
    
    tableRows.push({
      type: "tableRow",
      content: cells,
    });
  }

  return {
    type: "doc",
    content: [
      {
        type: "table",
        content: tableRows,
      },
    ],
  };
};
